import React from "react";

const AverageSalesNormalization = ({ row }) => {
  return (
    <div>
      {row?.averageSales?.toLocaleString()
        ? row?.averageSales?.toLocaleString()
        : "-"}
    </div>
  );
};

export default AverageSalesNormalization;
